import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CopyToClipboard from 'react-copy-to-clipboard';
import './CopyLink.scss';

function CopyLink({ url, shortForm = false, linkText = 'Copy link' }) {
  const [copied, setCopied] = useState(false);

  return (
    <div className="copy-link-container">
      {!shortForm && (
        <div>
          <label htmlFor="copy-link-url">Copy link to send invites manually</label>
        </div>
      )}
      <div className="row">
        {!shortForm && (
          <div className="col-xs-8">
            <input
              className="form-control"
              id="copy-link-url"
              type="text"
              value={url}
              readOnly
            />
          </div>
        )}
        <div className="col-xs-4">
          {copied ? (
            <span className="message-text">Link copied!</span>
          ) : (
            <CopyToClipboard text={url} onCopy={() => setCopied(true)}>
              <button type="button" className="btn btn-link btn-xs copy-link">
                {linkText}
              </button>
            </CopyToClipboard>
          )}
        </div>
      </div>
    </div>
  );
}

CopyLink.propTypes = {
  url: PropTypes.string.isRequired,
  shortForm: PropTypes.bool.isRequired,
  linkText: PropTypes.string.isRequired,
};

export default CopyLink;
